import { useNavigate } from "react-router-dom";
import styles from "./WorkDetailsNotFound.module.scss";

const HomeIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);
const GridIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
  </svg>
);
const ArrowLeftIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);
const SearchIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

// ─── SUGGESTION PILLS ────────────────────────────────────────────────────────
const SUGGESTIONS = [
  { label: "Web Apps", href: "#works" },
  { label: "Mobile", href: "#works" },
  { label: "Full Stack", href: "#works" },
  { label: "UI / UX", href: "#works" },
];

// ─── COMPONENT ───────────────────────────────────────────────────────────────
/**
 * ProjectNotFound
 *
 * Usage:
 *   <ProjectNotFound projectId="abc-123" />
 *
 * Props:
 *   projectId  — the invalid ID pulled from the URL (optional, shows a badge if provided)
 *   onGoBack   — function called when "Go Back" is clicked  (default: window.history.back)
 *   onGoWorks  — href for "View All Projects" link          (default: "#works")
 *   onGoHome   — href for "Home" link                       (default: "#home")
 */
export default function WorkDetailsNotFound({
  projectId = null,
  onGoBack = () => window.history.back(),
}) {
  const navigate = useNavigate();

  const onGoWorks = () => {
    navigate("/#projects");
  };

  const onGoHome = () => {
    navigate("/");
  };
  return (
    <>
      <section className={styles["pnf-section"]}>
        {/* ── MAIN CARD ── */}
        <div className={styles["pnf-card"]}>
          {/* eyebrow tag */}
          <div className={styles["pnf-tag"]}>
            <span className={styles["pnf-tag-dot"]} />
            Page Not Found
          </div>

          {/* 404 number */}
          <div className={styles["pnf-code"]}>
            4<span className={styles["pnf-code-accent"]}>0</span>4
          </div>

          {/* gold underline */}
          <div className={styles["pnf-underline"]} />

          {/* heading */}
          <h1 className={styles["pnf-heading"]}>No Project Details Found</h1>

          {/* description */}
          <p className={styles["pnf-desc"]}>
            The project you're looking for <strong>doesn't exist</strong> or may
            have been removed. Double-check the URL, or explore all available
            projects below.
          </p>

          {/* invalid project ID badge — only shown when ID is provided */}
          {projectId && (
            <div className={styles["pnf-id-badge"]}>
              <span className={styles["pnf-id-label"]}>Project ID</span>
              <span className={styles["pnf-id-sep"]} />
              <span className={styles["pnf-id-value"]}>{projectId}</span>
            </div>
          )}

          {/* divider */}
          <div className={styles["pnf-divider"]} />

          {/* action buttons */}
          <div className={styles["pnf-actions"]}>
            <button className={styles["pnf-btn-primary"]} onClick={onGoBack}>
              <ArrowLeftIcon />
              <span>Go Back</span>
            </button>
            <span className={styles["pnf-btn-outline"]} onClick={onGoWorks}>
              <GridIcon />
              All Projects
            </span>
            <span className={styles["pnf-btn-outline"]} onClick={onGoHome}>
              <HomeIcon />
              Home
            </span>
          </div>
        </div>

        {/* ── CATEGORY SUGGESTIONS ── */}
        {/* <div className={styles["pnf-sugg"]}>
                    <span className={styles["pnf-sugg-label"]}>Browse by category</span>
                    <div className={styles["pnf-sugg-row"]}>
                        {SUGGESTIONS.map(({ label, href }) => (
                            <a key={label} href={href} className={styles["pnf-sugg-pill"]}>
                                <SearchIcon />
                                {label}
                            </a>
                        ))}
                    </div>
                </div> */}
      </section>
    </>
  );
}
